import { render } from "./ReportCriterionRange.vue?vue&type=template&id=20c1de0a&scoped=true"
import script from "./ReportCriterionRange.vue?vue&type=script&lang=js"
export * from "./ReportCriterionRange.vue?vue&type=script&lang=js"

import "./ReportCriterionRange.vue?vue&type=style&index=0&id=20c1de0a&lang=scss&scoped=true"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c1de0a"]])

export default __exports__